module.exports = __webpack_public_path__ + "assets/img/he1.1.55bc323b.png";